import {inject, Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Observable, of} from 'rxjs';
import {concatMap, filter, map} from 'rxjs/operators';
import {StatusService} from 'src/app/shared/services/status/status.service';
import { TRANSLATE_PATH } from '../../project.model';
import {ResponseLoadConsentData} from 'build/project/openapi-cast/project/project-openapi-cast.model';
import {ProjectOpenapiCastService} from 'build/project/openapi-cast/project/project-openapi-cast.service';
import {TranslateDesignPipe} from 'src/app/shared/pipes/translate-design/translate-design.pipe';

@Injectable({
   providedIn: 'root'
})
export class ForwardService {
   
   public pTranslateDesign: TranslateDesignPipe = inject(TranslateDesignPipe);
   

   public TRANSLATE_PATH = TRANSLATE_PATH;

   public consentId: string = "";
   public consent: boolean = false;
   public afterLogin: boolean = false;

   constructor (public sProjectOpenapi: ProjectOpenapiCastService, private sStatus: StatusService) { }

   public loadConsent (): Observable<boolean> {

      const url = this.pTranslateDesign.transform(TRANSLATE_PATH.CONSENT_DECLARATION_AGREEMENTURL);

      if (url === TRANSLATE_PATH.CONSENT_DECLARATION_AGREEMENTURL) return of(false);

      let res = this.pTranslateDesign.transform(TRANSLATE_PATH.CONSENT_DECLARATION_DELAYTIMEREDIRECT); 
      this.sStatus.delayTimeRedirect = res !== TRANSLATE_PATH.CONSENT_DECLARATION_DELAYTIMEREDIRECT ? res : 2000;

      res = this.pTranslateDesign.transform(TRANSLATE_PATH.CONSENT_DECLARATION_TARGET);
      this.sStatus.target = res !== TRANSLATE_PATH.CONSENT_DECLARATION_TARGET ? res : '_blank'

      return this.sProjectOpenapi.loadConsent().pipe(
         map((res: ResponseLoadConsentData) => {
            if (res && res.consentId) {
               this.consent = true;
               this.consentId = res.consentId;
               this.sStatus.consentId =  res.consentId;
               this.afterLogin = res.afterLogin ?? false;
               this.sStatus.setAgreementUrl(url as string);
            }

            return this.consent;
         })
      ); 
   }

   public reset (): void {
      this.consentId = "";
      this.consent = false;
      this.afterLogin = false;
   }
}